
import { useState } from 'react';
import Hero from './components/Hero';
import FeaturedDestinations from './components/FeaturedDestinations';
import WhyChooseUs from './components/WhyChooseUs';
import TravelExperiences from './components/TravelExperiences';
import PopularBrands from './components/PopularBrands';
import HolidayDeals from './components/HolidayDeals';
import DigitalResources from './components/DigitalResources';
import PriceComparison from './components/PriceComparison';
import FflowRewards from './components/FflowRewards';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import axios from 'axios';

const Home = () => {

  const [noSponsorModal, setNoSponsorModal] = useState(false)
  const [referrerName, setReferrerName] = useState('')
  const sponsor = Cookies.get('sponsor')

  useEffect(() => {
    console.log('Found sponsor home page: ', sponsor)
    if (!sponsor) {
      console.log('sponsor not found')
      setNoSponsorModal(true)
    } else {
      // Show username immediately, then try to fetch full name
      setReferrerName(sponsor)
      fetchReferrerName(sponsor)
    }
  }, [])

  const fetchReferrerName = async (username: string) => {
    try {
      const response = await axios.get(`${import.meta.env.VITE_BASE_API}/api/users/${username}/stats`)
      const data = response.data

      if (data.ok && data.user) {
        const firstName = data.user.firstName || ''
        const lastName = data.user.lastName || ''

        if (firstName && lastName) {
          setReferrerName(`${firstName} ${lastName}`)
        } else if (firstName) {
          setReferrerName(firstName)
        }
        // If no name found, keep showing username (already set)
      }
    } catch (error) {
      console.error('Error fetching referrer name:', error)
      // Keep showing username on error (already set)
    }
  }

  const [userName, setUsername] = useState('')

  const handleVerify = async () => {
    if (userName == '') {
      return alert('Please enter your sponsor username')
    }


    const res = await axios.get(`${import.meta.env.VITE_BASE_API}/sponsor/validate/${userName}`)

    console.log('Ref validation res: ', res?.data)


    if (res?.data?.ok) {

      Cookies.set('sponsor', userName, {
        expires: 30,
        path: '/',
        sameSite: 'Lax'
      })

      setTimeout(() => {
        window.location.href = `/`
      }, 500)

    }
    else {
      // setPageLoading(false)
      alert('Sponsor not verified!')
    }
  }

  return (
    <div className="relative min-h-screen bg-white">
      {/* Referred By Banner */}
      {sponsor && referrerName && (
        <div className="fixed top-0 left-0 right-0 z-40 bg-gradient-to-r from-orange-500 to-amber-500 text-white py-2 px-4 text-center shadow-lg">
          <p className="text-sm md:text-base font-semibold">
            <i className="ri-user-star-line mr-2"></i>
            Referred by: <span className="font-bold">{referrerName}</span>
            <span className="text-orange-200 ml-2">(@{sponsor})</span>
          </p>
        </div>
      )}

      {noSponsorModal == true && <div className='!fixed z-50 w-screen h-screen flex items-center justify-center bg-black/50'>
        <div className='p-5 bg-white w-[95vw] md:!w-[450px]'>
          <h2 className='font-bold text-lg mb-5'>Who referred you?</h2>
          <div className='border p-2 rounded-sm mb-3'>
            <input onChange={e => setUsername(e.target.value)} className='w-full ring-0 border-0 outline-none' placeholder='Enter your sponsor username here' />
          </div>
          <button onClick={handleVerify} className='w-full py-2 bg-black text-white'>Verify Sponsor</button>
        </div>
      </div>}
      <Hero />
      <FeaturedDestinations />
      <WhyChooseUs />
      <TravelExperiences />
      <PopularBrands />
      <HolidayDeals />
      <DigitalResources />
      <PriceComparison />
      <FflowRewards />
      <Testimonials />
      <Footer />


    </div>
  );
};

export default Home;
